import type { GridApi, GridColDef } from '@mui/x-data-grid-premium';
import { VyTableWaterfall } from '../../../../components/new-design/table/vy-table/VyWaterfallTable';
import type { RetentionRow } from '../utils/build-retention-rows';

type NrrGrrReportTableProps = {
  rows: RetentionRow[];
  columns: GridColDef<RetentionRow>[];
  isLoading?: boolean;
  apiRef?: React.MutableRefObject<GridApi>;
  initialColumnVisibility?: Record<string, boolean>;
};

export const NrrGrrReportTable: React.FC<NrrGrrReportTableProps> = ({
  rows,
  columns,
  isLoading,
  apiRef,
  initialColumnVisibility,
}) => (
  <VyTableWaterfall
    apiRef={apiRef}
    columns={columns}
    items={rows}
    loadingItems={isLoading}
    initialColumnVisibility={initialColumnVisibility}
    density="compact"
    hideFooter
  />
);
